import logo from "@/assets/veloskin-logo.png";

export const BrandMark = ({ className = "h-9" }) => (
  <img
    src={logo}
    alt="Veloskin PPF"
    draggable="false"
    className={`w-auto select-none object-contain ${className}`}
  />
);
